<template>
	<app-content style="position: relative;" >
		<div class="mask" v-if="User.role =='View' || form.auditMemberId"></div>
		<div class="h-panel" style="width: 1000px;margin: 0 auto;padding-top: 20px;">
			<img v-if="form.auditMemberId" class="auditpic" src="@/assets/audit.png" alt="已审核">
			<div class="padding-right-left">
				<Row type="flex" :space-x="10">
					<Cell v-if="User.role !='View'">
						<template v-if="isCheck">
							<Button v-if="isCheck" @click="$router.back()">返回</Button>
							<Button :disabled="!canSave" color="primary" @click="save(true)" :loading="loading">保存</Button>
						</template>
						<template v-else>

              <!-- 保存并新增按钮：仅在新凭证（无 ID）时显示，当表单可保存时启用，点击后保存当前凭证并创建新凭证 -->
							<Button :disabled="!canSave" color="primary" @click="save(true)" :loading="loading" v-if="!form.id" v-tooltip content="保存并新增 (Alt + S)">保存并新增</Button>
              <!-- 新增按钮：当凭证已审核时禁用，点击后跳转到新增凭证页面 -->
              <Button :disabled="!!form.auditMemberId" color="primary" @click="toNew()" v-else>新增</Button>
              <!-- 保存按钮：当表单不可保存或凭证已审核时禁用，点击后保存当前凭证但不跳转，参数 false 表示保存后不新增 -->
              <Button :disabled="!canSave || !!form.auditMemberId" color="primary" @click="save(false)" :loading="loading">保存</Button>
							<template v-if="form.id && currentAccountSets.voucherReviewed">
								<Button v-if="form.auditMemberId" color="primary" @click="cancelAudit" :loading="loading">取消审核</Button>
								<Button v-else color="primary" @click="audit" :loading="loading">审核</Button>
							</template>
						</template>
					</Cell>
					<Cell v-if="!isCheck && form.id">
						<a class="h-btn" :href="`/api/pfd/voucher?id=${form.id}`" target="_blank">打印</a>
					</Cell>
					<Cell :flex="1" class="text-right" v-if="!isCheck">

            <ButtonGroup>
              <Button :loading="loading" @click="first" size="s" v-tooltip content="第一条" ><<</Button>
              <Button :loading="loading" @click="before" size="s" v-tooltip content="上一条" icon="h-icon-left"></Button>
              <Button :loading="loading" @click="next" size="s" v-tooltip content="下一条" icon="h-icon-right"></Button>
              <Button :loading="loading" @click="last" size="s" v-tooltip content="最后一条">>></Button>
            </ButtonGroup>
					</Cell>
				</Row>
				<Row class="margin-top" type="flex" :space-x="10">
					<Cell>
						<Select @change="loadCode" keyName="word" titleName="word" style="min-width: 70px" :deletable="false" :datas="voucherWords" v-model="form.word" placeholder="记"/>
					</Cell>
					<Cell class="label">
						<NumberInput :min="1" v-model="form.code" v-width="90" style="display: inline-block"/>
						号
					</Cell>
					<Cell class="label">
						日期：
					</Cell>
					<Cell class="label">
						<DatePicker :disabled="!!carryForward" :option="dpOps" :clearable="false" v-model="form.voucherDate" format="YYYY-MM-DD"/>
					</Cell>
					<Cell class="label">
						<DropdownCustom :toggle-icon="false" class-name="h-text-dropdown">
							<span class="text-hover blue-color font-bold">备注</span>
							<div slot="content" v-width="200">
								<textarea placeholder="请输入备注内容" v-model="form.remark" v-autosize rows="3" style="width: 100%;"></textarea>
							</div>
						</DropdownCustom>
					</Cell>
				</Row>
			</div>
			<voucher-table ref="voucherTable" v-model="voucherTable"/>
			<div class="padding-right-left padding-bottom">
				制单人：{{User.realName}}
			</div>
		</div>
	</app-content>
</template>

<script>
	import VoucherTable from "../../components/VoucherTable";
	import {mapState} from 'vuex';
	import moment from 'moment';
  /**
   * 用于实现凭证表单功能。
   * 该组件支持凭证的创建、编辑、审核、取消审核等操作，
   * 同时提供打印、上下条切换等辅助功能。
   */
	export default {
		name: "VoucherForm",
		components: {VoucherTable},
		inject: ['reload'],
		props: {
      /**
       * 凭证 ID 属性
       * 用于接收父组件传递的凭证标识符，支持数字和字符串类型
       * 当存在该值时加载已有凭证数据，为空时表示新增凭证模式
       */
			voucherId: [Number, String],
		},
				computed: {
			/**
			 * 使用 mapState 辅助函数从 Vuex 状态中映射出 User 和 currentAccountSets 属性
			 * 这样可以在组件中直接使用 this.User 和 this.currentAccountSets 访问 Vuex 状态
			 */
			...mapState(['User', 'currentAccountSets']),
			/**
			 * 获取凭证条目数组
			 * @returns {Array} 从 voucherTable 组件中获取的凭证条目数组
			 */
			voucherItems() {
				return this.voucherTable.voucherItems;
			},
			/**
			 * 判断是否可以保存凭证
			 * 当凭证条目数组的长度大于 0 时，表示有可保存的数据，返回 true；否则返回 false
			 * @returns {boolean} 是否可以保存凭证
			 */
			canSave() {
				return this.voucherItems.length > 0
			},
			/**
			 * 判断当前是否处于检查模式
			 * 若路由参数中存在 checkData 属性，则认为处于检查模式，返回 true；否则返回 false
			 * @returns {boolean} 是否处于检查模式
			 */
			isCheck() {
				return !!this.$route.params.checkData
			}
		},

		data() {
			return {
        // 控制加载状态的布尔值，用于显示加载动画
        loading: false,
        // 标识是否为结转凭证的布尔值
        carryForward: false,
        // 存储凭证字号列表的数组
        // 数组元素为对象，包含凭证字号的相关信息
        voucherWords: [],
        // 存储凭证表格数据的对象
        // voucherItems 为数组，包含凭证条目的详细信息
        voucherTable: {voucherItems: []},
        // 存储所有辅助核算列表的数组
        auxiliaryAll: [],
        // 日期选择器的配置对象
        // start 属性指定日期选择器的起始日期，初始值为当前日期
        dpOps: {
          start: moment().toDate()
        },
        // 存储从后端获取的完整凭证数据的对象
        // 初始为空对象，当加载凭证数据时会填充具体内容
        voucher: {},
							// 表单数据对象，用于存储凭证相关信息
				form: {
					// 凭证备注信息，初始为空字符串
					remark: '',
					// 凭证字号，例如“记”字，初始为空字符串
					word: '',
					// 凭证编号，初始为空字符串
					code: '',
					// 凭证日期，格式为字符串，初始为空字符串
					voucherDate: '',
					// 是否为结转凭证，布尔类型，初始为 false
					carryForward: false,
				},
        isAuxiliaryLoading: false, // 添加防重标识
        saveShortcutLock: false,
			}

		},
		watch: {
      /**
       * 监听凭证字号变化，自动加载对应的凭证编号
       * @param {String} val - 新的凭证字号值
       * @param {String} old - 旧的凭证字号值
       */
			'form.word'(val, old) {
        // 如果是首次加载（old 为空）且存在凭证 ID，说明正在加载已有凭证数据，无需重新获取编号
				if (!old && this.voucherId) {
					return;
				}
        // 凭证字号发生变化时，调用 loadCode() 方法重新获取凭证编号
				val && this.loadCode();
			},
      /**
       * 监听凭证 ID 变化，重新初始化表单或刷新页面
       * @param {Number|String} val - 新的凭证 ID 值
       */
			voucherId(val) {
        // 当凭证 ID 被清空时，执行页面刷新操作，返回到新增凭证状态
				if (!val) {
					this.reload()
				} else {
          // 当凭证 ID 变化时，调用 init() 方法加载对应凭证的数据
					this.init();
				}
			}
		},
		beforeRouteLeave(to, from, next) {
			next();
		},
		methods: {
					/**
			 * 加载凭证字号列表，并设置默认凭证字号
			 * 该方法会调用 API 获取凭证字号列表，将返回的数据存储到 voucherWords 数组中，
			 * 同时从返回数据里找出默认凭证字号并设置到表单对象的 word 属性中
			 */
			loadVoucherWords() {
				// 调用 API 获取凭证字号列表
				this.$api.setting.voucherWord.list().then(({data}) => {
					// 将返回的凭证字号数据赋值给 voucherWords 数组，若 data 为空则赋值为空数组
					this.voucherWords = data || [];
					// 从返回的数据中查找默认的凭证字号对象
					// 若找到默认凭证字号对象，则将其 word 属性值赋值给表单对象的 word 属性
					// 若未找到，代码会因尝试访问 null 的 word 属性而报错，可添加空值检查避免
					this.form.word = data.find(value => value.isDefault).word
				})
			},

      handleShortcutSave(event) {

        // 组件已销毁则直接返回，避免残留监听器导致的重复保存
        if (this._isDestroyed || this._isBeingDestroyed) {
          return;
        }

        if (event.altKey && event.key === 's' && this.canSave && !this.form.auditMemberId && !this.loading) {
          event.preventDefault();
          event.stopPropagation();  // ✅ 阻止事件冒泡

          if (this.saveShortcutLock) {  // ✅ 检查锁状态
            return;
          }

          this.saveShortcutLock = true;  // ✅ 上锁
          this.save(true);

          setTimeout(() => {
            this.saveShortcutLock = false;  // ✅ 800ms 后解锁
          }, 2500);
        }
      },

      /**
			 * 加载凭证编号的方法。
			 * 该方法会调用 API，根据当前选择的凭证字号和凭证日期，从后端获取对应的凭证编号，
			 * 并将获取到的凭证编号赋值给表单的 `code` 属性。
			 */
			loadCode() {
				// 调用 API 并传入当前凭证字号和凭证日期，请求对应的凭证编号
				this.$api.voucher.loadCode({
					word: this.form.word, // 当前选择的凭证字号
					currentAccountDate: this.form.voucherDate // 当前凭证日期
				}).then(({data}) => {
					// 将从后端获取的凭证编号赋值给表单的 code 属性
					this.form.code = data
				})
			},
      /**
       * 跳转到新增凭证页面的方法
       * 该方法通过路由跳转至凭证表单的新建状态，用于在已审核凭证等场景下创建新凭证
       * @returns {void}
       */
			toNew() {
        // 调用清空表单方法
        this.clearForm();
				this.$router.push({name: 'VoucherForm'});
			},

      // 添加调试方法来查看 voucherItems 信息
      debugVoucherItems() {
        console.log('voucherItems 信息:', this.voucherItems);
        console.log('voucherItems 长度:', this.voucherItems.length);
        console.log('voucherItems 详细数据:', JSON.stringify(this.voucherItems, null, 2));
      },

			save(next) {

        if (this.loading) {
          return;
        }

        this.loading = true;

        if (!this.form.code) {
          this.loading = false;
					this.$Message("亲，请输入编号！");
					return
				}

				if (!this.voucherItems.length) {
          this.loading = false;
					this.$Message("亲，第1行不能为空！");
					return
				}

				if (this.checkItem("摘要", 'summary') || this.checkItem("科目", 'subjectId') || this.checkItem("金额")) {
          this.loading = false;
          return
				}

				if (this.voucherTable.jfTotal != this.voucherTable.dfTotal) {
          this.loading = false;
          this.$Message("亲，借贷不平衡！");
					return
				}

        // 处理辅助核算数据  同时有多个辅助核算时
        if (this.voucherItems && this.voucherItems.length > 0 ) {
          this.voucherItems.forEach(detail => {
            if (detail.auxiliaryTitle) {
              const parts = detail.auxiliaryTitle.split('_');
              // 提取第 1 个和第 3 个下划线后的值（索引为 1 和 3）
              const codes = [parts[1], parts[3]].filter(Boolean);

              // 在 this.auxiliaryAll 中查找所有匹配的值
              const foundAuxiliaries = this.auxiliaryAll.filter(item =>
                  codes.includes(item.code)
              );

              // 如果找到了匹配的值，则赋值给 detail.auxiliary
              if (foundAuxiliaries && foundAuxiliaries.length > 0) {
                detail.auxiliary = foundAuxiliaries;
              }
            }
          })
        }

        // console.log('voucherItems 详细数据:', JSON.stringify(this.voucherItems, null, 2));
				this.$api.voucher[this.voucherId ? 'update' : 'save'](Object.assign({}, this.form, {details: this.voucherItems, createMember: this.User.id})).then(({success, data}) => {

          // 保存成功后，仅在新凭证（无 ID）场景下执行后续跳转逻辑
          if (success && !this.form.id) {
            // 根据 next 参数判断保存后是否新增：true 表示保存并新增/刷新，false 表示仅保存
						if (next) {

              // 检查模式：保存成功后返回上一页；非检查模式：刷新当前页面
							if (!this.isCheck) {

                // 调用清空表单方法
                this.clearForm();
								this.reload();

							} else {
								this.$router.back();// 检查模式：返回上一页
							}
						} else {
              // 跳转到新保存的凭证编辑页面，传入凭证 ID
							// this.$router.push({name: 'VoucherForm', params: {voucherId: data.id}});

              // 清空表单后跳转到新凭证
              this.clearForm();
              this.$nextTick(() => {
                this.$router.push({name: 'VoucherForm', params: {voucherId: data.id}});
              });
						}
					}

					this.loading = false;
					// this.$Message("亲，保存成功！");
					//如果是结转凭证就返回
					if (this.$route.params.checkData) {
						this.$router.back();
					}
          // 显示保存成功提示（排除检查模式和结转凭证场景）
          if (!this.$route.params.checkData)  {
            this.$Message("亲，保存成功！");
          }
				}).catch(() => {
					this.loading = false;
          this.$Message("亲，保存失败！");
				});
			},

      /**
       * 清空表单数据的方法
       * 用于重置凭证表单和表格数据到初始状态
       */
      clearForm() {
        // 清空表单对象的所有字段
        this.form = {
          remark: '',
          word: '',
          code: '',
          voucherDate: '',
          carryForward: false,
        };
        // 清空凭证表格数据
        this.voucherTable = {voucherItems: []};
      },


      checkItem(name, field) {
				let i = 0, len = this.voucherItems.length, row = -1;
				for (; i < len; i++) {
					if ((field && !this.voucherItems[i][field]) || (!field && !this.voucherItems[i].debitAmount && !this.voucherItems[i].creditAmount)) {
						row = i + 1;
						break;
					}
				}

				if (row > -1) {
					this.$Message(`亲，第${row}行，请输入${name}！`);
					return true;
				}
			},
      /**
       * 获取并跳转到上一条凭证记录
       *
       * 该函数通过当前凭证ID查询上一条凭证记录，如果存在则跳转到对应的凭证编辑页面，
       * 如果不存在则提示用户已无上一条记录。
       *
       * @returns {void}
       */
			before() {
        // 设置加载状态为true，显示加载动画
				this.loading = true;
        // 调用API接口查询上一条凭证ID
        // console.log('查询上条凭证ID:', this.voucherId);
				this.$api.voucher.beforeId({currentId: this.voucherId}).then(({data}) => {
          // 如果返回了上一条凭证ID，则跳转到对应凭证的编辑页面
					if (data) {
						this.$router.push({name: 'VoucherForm', params: {voucherId: data}}).catch(err => {
              if (err.name !== 'NavigationDuplicated') {
                throw err;
              }
            });
					} else {
            // 如果没有上一条凭证，给用户提示信息
						this.$Message("亲，已经没有上一条啦！")
					}
				}).finally(() => {
          // 无论成功或失败，最终都要关闭加载状态
					this.loading = false;
				});

			},
      first() {
        // 设置加载状态为true，显示加载动画
        this.loading = true;
        // 调用API接口查询第一条凭证ID
        // console.log('查询第一条凭证ID:', this.voucherId);
        this.$api.voucher.firstId({currentId: this.voucherId}).then(({data}) => {
          // 如果返回了第一条凭证ID，则跳转到对应凭证的编辑页面
          if (data) {
            this.$router.push({name: 'VoucherForm', params: {voucherId: data}}).catch(err => {
              if (err.name !== 'NavigationDuplicated') {
                throw err;
              }
            });
          } else {
            // 如果没有第一条凭证，给用户提示信息
            this.$Message("亲，已经没有第一条啦！")
          }
        }).finally(() => {
          // 无论成功或失败，最终都要关闭加载状态
          this.loading = false;
        });
      },
			next() {
				this.loading = true;
        // console.log('查询下条凭证ID:', this.voucherId);
				this.$api.voucher.nextId({currentId: this.voucherId}).then(({data}) => {
					if (data) {
						this.$router.push({name: 'VoucherForm', params: {voucherId: data}}).catch(err => {
              if (err.name !== 'NavigationDuplicated') {
                throw err;
              }
            });
					} else {
						this.$Message("亲，已经没有下一条啦！")
					}
				}).finally(() => {
					this.loading = false;
				});

			},
      last() {
        this.loading = true;
        // console.log('查询下条凭证ID:', this.voucherId);
        this.$api.voucher.lastId({currentId: this.voucherId}).then(({data}) => {
          if (data) {
            this.$router.push({name: 'VoucherForm', params: {voucherId: data}}).catch(err => {
              if (err.name !== 'NavigationDuplicated') {
                throw err;
              }
            });
          } else {
            this.$Message("亲，已经没有最后一条啦！")
          }
        }).finally(() => {
          this.loading = false;
        });
      },



						/**
			 * 初始化凭证表单数据的方法
			 * 若存在凭证 ID，则从后端加载对应凭证数据；若不存在，则设置默认凭证日期
			 */
			init() {
				// 检查是否传入了凭证 ID
        // console.log('进入初始化凭证方法，此时的voucherId:', this.voucherId)
				if (this.voucherId) {
					// 若存在凭证 ID，调用 API 加载对应凭证的数据
					this.$api.voucher.load(this.voucherId).then(({data}) => {

            // console.log('data.details 详细数据:', JSON.stringify(data.details, null, 2));
						// 调用 voucherTable 组件的 initValue 方法，将从后端获取的凭证明细数据传入进行初始化
						this.$refs.voucherTable.initValue(data.details);
						// 将从后端获取的完整凭证数据赋值给 voucher 属性
						this.voucher = data;
						// 将从后端获取的部分凭证数据赋值给表单对象 form
						this.form = {
							id: data.id, // 凭证 ID
							auditMemberId: data.auditMemberId, // 审核人 ID
							word: data.word, // 凭证字号
							remark: data.remark, // 凭证备注
							voucherDate: data.voucherDate, // 凭证日期
							carryForward: data.carryForward, // 是否为结转凭证
							code: data.code // 凭证编号
						};
					})
				} else {
					// 若不存在凭证 ID，将凭证日期设置为当前账套日期所在月份的最后一天，格式为 YYYY-MM-DD
					// this.form.voucherDate = moment(this.currentAccountSets.currentAccountDate).endOf('month').format('YYYY-MM-DD');

          // 根据账套日期与当前月份的比较，设置不同的默认凭证日期
          const currentAccountDate = moment(this.currentAccountSets.currentAccountDate);
          const today = moment();

          // 获取账套日期的年月和当前日期的年月
          const accountYearMonth = currentAccountDate.format('YYYY-MM');
          const currentYearMonth = today.format('YYYY-MM');

          // 比较账套日期月份与当前月份
          if (accountYearMonth < currentYearMonth) {
            // 账套日期月份 < 当前月份：设置为账套日期所在月的月末
            this.form.voucherDate = currentAccountDate.endOf('month').format('YYYY-MM-DD');
          } else if (accountYearMonth === currentYearMonth) {
            // 账套日期月份 = 当前月份：设置为当前系统日期
            this.form.voucherDate = today.format('YYYY-MM-DD');
          } else {
            // 账套日期月份 > 当前月份：设置为账套日期所在月的月初
            this.form.voucherDate = currentAccountDate.startOf('month').format('YYYY-MM-DD');
          }

        }


				//结转凭证初始化
        /**
           * 初始化凭证表单数据，根据路由参数加载科目余额并构建明细项
           *
           * @description 根据路由中的 checkData 和 type 参数，判断是否为结转操作，
           *              并据此设置凭证日期、摘要及借贷金额等信息。
           *              最后将处理后的明细数据初始化到 voucherTable 组件中。
        */
				let params = this.$route.params;
				if (params.checkData) {
          // 判断是否是结转损益类型的操作
					this.carryForward = !!params.type.code;

          // 设置凭证日期为当前检查月份的最后一天
					this.form.voucherDate = moment(params.checkData.checkYear + "-" + params.checkData.checkMonth).endOf('month').format('YYYY-MM-DD');
					let {subject, name} = params.type;
					let details = [];

          // 请求获取指定科目的余额数据
          this.$api.setting.subject.loadByCode(subject, Object.assign(params.checkData, {name})).then(({data}) => {

            let totalDebit = 0; // 用于累计借方总额
            let totalCredit = 0; // 用于累计贷方总额

            // 第一步：过滤掉2001科目，处理其他科目
            let filteredSubjects = data.subject.filter(sub => sub.code !== '2001');

            // 遍历过滤后的科目列表，构造每一条分录明细
            filteredSubjects.forEach(sub => {
              let amount = data.amount[sub.code];
              // 构造基础明细对象
              let detail = {
                summary: `第${params.checkData.checkMonth}期 ${name}`,
                subject: sub,
                subjectId: sub.id,
                subjectName: `${sub.code}-${sub.name}`,
                subjectCode: sub.code
              };

              if (amount) {
                if (name !== "结转拨款") {
                  // 对于"结转上缴款项"，计算借方-贷方的结果，并将其绝对值计入贷方
                  if (sub.code === '3002'|| (sub.code && sub.code.startsWith('3001'))) {
                    // 特殊情况：当科目为3002时，计算贷方-借方的结果计入借方
                    let netAmount = (amount.creditAmount || 0) - (amount.debitAmount || 0);
                    if (netAmount !== 0) {
                      detail.debitAmount = netAmount;
                      totalDebit += netAmount;
                      details.push(detail);
                    }
                  } else {
                    // 普通情况：计算借方-贷方的结果计入贷方
                    let netAmount = (amount.debitAmount || 0) - (amount.creditAmount || 0);
                    if (netAmount !== 0) {
                      detail.creditAmount = netAmount;
                      totalCredit += netAmount;
                      details.push(detail);
                    }
                  }
                }  else if (name === "结转拨款") {
                  // 对于"结转拨款"，计算贷方-借方差额，并将结果计入借方
                  let netAmount = (amount.creditAmount || 0) - (amount.debitAmount || 0);
                  if (netAmount !== 0) {
                    // 贷方-借方结果计入借方
                    detail.debitAmount = netAmount;
                    totalDebit += netAmount;
                    details.push(detail);
                  }
                }
              }
            });

            // 第二步：添加2001科目，将所有贷方的和计入2001科目的借方
            if (totalCredit || totalDebit) {
              let subject2001 = data.subject.find(sub => sub.code === '2001');
              if (subject2001) {
                let detail2001 = {
                  summary: `第${params.checkData.checkMonth}期 ${name}`,
                  subject: subject2001,
                  subjectId: subject2001.id,
                  subjectName: `${subject2001.code}-${subject2001.name}`,
                  subjectCode: subject2001.code,
                };

                if (name === "结转拨款" && totalDebit) {
                  // 当name为"结转拨款"时，将累计的所有借方金额作为2001科目的贷方金额
                  detail2001.creditAmount = totalDebit;
                } else if ((totalDebit-totalCredit) > 0) {
                  // 其他情况下，将所有贷方的和计入2001科目的借方
                  detail2001.creditAmount = totalDebit-totalCredit;
                } else {
                  // 当totalCredit为0时，将totalDebit作为2001科目的借方金额
                  detail2001.debitAmount = totalCredit-totalDebit;
                }

                details.push(detail2001);
              }
            }

            // 将最终生成的明细数据传入表格组件进行初始化
            this.$refs.voucherTable.initValue(details);
          });
				}
              // 加载可用的凭证字选项
				this.loadVoucherWords();
			},

			audit() {
				this.$Confirm("亲，确认要审核吗?").then(() => {
					this.loading = true;
					this.$api.voucher.audit({checked: [this.voucher.id], year: this.voucher.voucherYear, month: this.voucher.voucherMonth}).then(() => {
						this.reload();
						this.$Message("审核成功！");
					}).finally(() => {
						this.loading = false;
					});
				});
			},
			cancelAudit() {
				this.$Confirm("亲，确认要取消审核吗?").then(() => {
					this.loading = true;
					this.$api.voucher.cancelAudit({checked: [this.voucher.id], year: this.voucher.voucherYear, month: this.voucher.voucherMonth}).then(() => {
						this.reload();
						this.$Message("取消审核成功！");
					}).finally(() => {
						this.loading = false;
					});
				});
			},

      /**
       * 加载辅助核算列表数据
       *
       * @description 从API获取会计科目分类列表数据，设置辅助核算类型选项，并默认选中第一个选项
       * @returns {void}
       */

      loadAuxiliarAll() {

        // 添加防重检查
        if (this.isAuxiliaryLoading) {
          console.warn('辅助核算数据正在加载中，避免重复请求');
          return Promise.resolve();
        }

        // 设置加载状态
        this.isAuxiliaryLoading = true;

        // 返回 Promise 以便调用方可以等待加载完成
        return this.$api.accountbook.loadAuxiliaryAll().then(({data}) => {
          this.auxiliaryAll = data;
          this.isAuxiliaryLoading = false; // 加载完成后重置状态
        }).catch(error => {
          console.error('加载辅助核算列表数据失败:', error);
          this.isAuxiliaryLoading = false; // 错误时也要重置状态
          // 即使加载失败也要让 Promise resolve，避免阻塞其他流程
          return Promise.resolve();
        });
      },
		},
		mounted() {
      // this.loadAuxiliarAll();
			// this.$set(this.dpOps, "start", moment(this.currentAccountSets.enableDate).toDate());
			// this.init();
      // 先加载辅助核算数据
      this.loadAuxiliarAll().then(() => {
        // 再设置日期选项和初始化表单
        this.$set(this.dpOps, "start", moment(this.currentAccountSets.enableDate).toDate());
        this.init();
       // console.log("新增界面加载完成,此时的voucherId:", this.voucherId)

      });
      // 在 document 上监听 keydown 事件
      document.addEventListener('keydown', this.handleShortcutSave);

		},

    // keep-alive 场景下：激活时幂等地重挂监听器（先移除再添加，避免重复）
    activated() {
      document.removeEventListener('keydown', this.handleShortcutSave);
      document.addEventListener('keydown', this.handleShortcutSave);
    },
    // keep-alive 场景下：失活时移除监听器，避免被缓存的实例响应快捷键
    deactivated() {
      document.removeEventListener('keydown', this.handleShortcutSave);
    },

    beforeDestroy() {
      // 组件销毁时移除事件监听器（Vue 2 使用 beforeDestroy，而非 Vue 3 的 beforeUnmount）
      document.removeEventListener('keydown', this.handleShortcutSave);
    }
	}
</script>

<style scoped>
	.mask {
		position: absolute;
		height: 100%;
		width: 100%;
		z-index: 100;
		bottom: 0;
		top: 110px;
	}

	.auditpic {
		position: absolute;
		z-index: 100;
		right: 100px;
	}
</style>
